import { motion } from "framer-motion"
import features1 from "../assets/svg/features.svg"

const features = [
  "Comprehensive Record Management",
  "Advanced Financial Tracking",
  "Cloud Backup & Data Management",
  "Dashboard for Key Metrics",
  "Vehicle Logistics & Loading Management",
  "Powerful Reporting & Analysis",
  "Access Control & Security Logs",
  "Subscription Management",
  "Automated Printing Solutions",
  "User & Role Management",
]

const svgVariants = {
  hidden: { opacity: 0, scale: 0.8, rotate: -10 },
  visible: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { duration: 0.8, ease: "easeOut" },
  },
}

export function ExcitingFeatures() {
  return (
    <section className="w-full py-16 sm:py-24 lg:py-32 px-4 bg-[#F6F6F6]">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8 lg:gap-24">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="relative flex justify-center"
            style={{ perspective: "1200px" }}
          >
            <motion.img
              src={features1}
              alt="Features Illustration"
              className="w-full h-auto max-h-[500px] lg:max-h-[700px] object-contain"
              variants={svgVariants}
              style={{ maxWidth: "100%" }}
              whileHover={{
                scale: 1.05,
                rotateY: 10,
                rotateX: 10,
                transition: { duration: 0.3, ease: "easeOut" },
              }}
            />
          </motion.div>

          <div className="pt-8 lg:pt-0">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-gray-900 font-bold text-center lg:text-left mb-8 lg:mb-12"
              style={{
                fontFamily: "Roboto, sans-serif",
                fontSize: "clamp(28px, 5vw, 42px)",
                lineHeight: "1.2",
              }}
            >
              Exciting Features!
            </motion.h2>

            <motion.ul
              className="space-y-2 sm:space-y-[3px]"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={{
                visible: {
                  transition: {
                    staggerChildren: 0.1,
                  },
                },
              }}
            >
              {features.map((feature, index) => (
                <motion.li
                  key={index}
                  className="flex items-center gap-3 sm:gap-6 text-gray-900 font-semibold pl-2 sm:pl-4"
                  variants={{
                    hidden: { opacity: 0, x: 20 },
                    visible: { opacity: 1, x: 0 },
                  }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                  whileHover={{ scale: 1.02, x: 10, transition: { duration: 0.3 } }}
                  style={{
                    fontFamily: "Roboto, sans-serif",
                    fontSize: "clamp(16px, 3vw, 20px)",
                    lineHeight: "1.4",
                  }}
                >
                  <motion.span
                    className="h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-black flex-shrink-0"
                    whileHover={{ scale: 1.2, transition: { duration: 0.2 } }}
                  />
                  {feature}
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </div>
      </div>
    </section>
  )
}

